import Vue from 'vue'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import vueSmoothScroll from 'vue2-smooth-scroll'
import GPay from '@/components/widgets/google-pay/index.vue'
import CryptoPaymentPopup from '@/components/popup-crypto-pay/index.vue'
import GCFPaymentPopup from '@/components/popup-gcf-pay/GCFPaymentPopup.vue' // Добавляем импорт нового компонента
import axios from 'axios' // Add axios import here

import {
  BUY_COUNT_FREE_TREES,
  BUY_SELECT_YOUNG_TREES,
  BUY_YOUNG_TREE,
  CHECK_PROMO_CODE,
  FETCH_PAYMENTS_SYSTEM,
  LOAD_USER_DATA,
  PAYMENT_LEOGAMING,
  POPUP_BUY_IFRAME
} from '@/store/mutation-types';
import _ from 'lodash'
import store from "@/store";

Vue.use(vueSmoothScroll);

export default {
  name: 'buy-default-tree',
  data() {
    return {
      countLoader: false,
      sliderValue: 0,
      showPayment: false,
      value: '',
      paySystem: null,
      payload: {
        tree_count: 0,
        payment_system: '',
        promoCode: '',
        promoArea: 'firstsale_buy'
      },
      showCryptoPopup: false,
      showGCFPopup: false,
      gcfPaymentData: null, // Add this to store Teido payment data
      maxAmounts: {
        BetaTransferCrypto: 5000,
        BetaTransferUkraine: 405,
        BetaTransferAZN: 2835,
        BetaTransferKZT: 400,
        GCFPay: 5000
      }
    }
  },
  components: {
    GPay,
    CryptoPaymentPopup,
    GCFPaymentPopup
  },
  computed: {
    ...mapGetters({
      user: `profile/user`,
      setting: 'main/setting',
      isLoadingCountryCode: 'main/isLoadingCountryCode',
      countFreeTrees: `profileBuyTree/countFreeTrees`,
      payments: `profileBuyTree/payments`,
      selectYoungTrees: `profileBuyTree/selectYoungTrees`,
      promoData: `profileBuyTree/promoData`,
      promoDataLoading: `profileBuyTree/promoDataLoading`,
      fetchUserData: `profile/user`,
      gcfLoading: 'gcf_store/isLoading',
      gcfError: 'gcf_store/getError',
    }),
    ...mapGetters('new_user',{
      uuid: "uuid",
    }),
    preparePayments(){
      if (!this.payments){
        return [];
      }
      return [
        ...this.payments,
        {
          payment_system: "BetaTransferCrypto",
          restriction: null
        },
        // {
        //   payment_system: "BetaTransferUkraine",
        //   restriction: null
        // },
        // {
        //   payment_system: "BetaTransferAZN",
        //   restriction: null
        // },
        // {
        //   payment_system: "BetaTransferKZT",
        //   restriction: null
        // },
        {
          payment_system: "GCFPay", // Добавляем новую платежную систему
          restriction: null
        }
      ]
    },
    isAmountValid() {
      if (!this.payload.payment_system || !this.totalPrice) {
        return false;
      }

      const maxAmount = this.maxAmounts[this.payload.payment_system];
      return maxAmount ? this.totalPrice <= maxAmount : true;
    },
    totalCashBack() {
      let total = this.setting.defaultPriceTree * this.payload.tree_count;
      if (this.promoData) {
        if (this.promoData.cashback > 0) {
          total = Math.round((total * (this.promoData.cashback / 100)) * 10000) / 10000
        }
      }
      return total;
    },
    totalPrice() {
      let total = this.setting.defaultPriceTree * this.payload.tree_count;
      if (this.promoData) {
        if (this.promoData.discount > 0) {
          total = total - (total * (this.promoData.discount / 100));
          total = Math.round(total * 100) / 100
        }
      }
      if (this.payload.promoCode.length === 0) {
        total = this.setting.defaultPriceTree * this.payload.tree_count
      }
      return total;
    },
    watchCount() {
      if (this.payload.tree_count > this.countFreeTrees.all_young_trees_count) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.fetchUser().then(() => {
      this.setUuidAsync(this.fetchUserData.uuid)
    })
    this.fetchParams()
        .then(response => {
          if (this.selectYoungTrees !== 0) {
            if (response.data.all_young_trees_count < this.selectYoungTrees) {
              this.payload.tree_count = response.data.all_young_trees_count;
            } else {
              this.payload.tree_count = this.selectYoungTrees;
            }
          }
        })
        .finally(() => {
          this.countLoader = true;

        });
    if (this.isLoadingCountryCode) {
      this.fetchPayments({countryCode: this.setting.countryCode});
    }
    if (window.innerWidth < 981) {
      this.$smoothScroll({
        hash: '',
        duration: 1000,
        updateHistory: false,
        scrollTo: document.getElementById('buy__default'),
      })
    }
  },
  watch: {
    isLoadingCountryCode() {
      if (this.isLoadingCountryCode) {
        this.fetchPayments({countryCode: this.setting.countryCode});
      }
    }
  },
  methods: {
    ...mapActions('new_acquiring',{
      buyYoungOliveTreesStripeAsync: 'buyYoungOliveTreesStripeAsync',
      buyYoungOliveTreesBetaTransferAsync: 'buyYoungOliveTreesBetaTransferAsync',
    }),
    ...mapActions('gcf_store',{
      // Добавляем action для GCF
      initGCFAsync: 'initGCFAsync',
      verifyGCFPaymentAsync: 'verifyGCFPaymentAsync',
      notifyWebhookAsync: 'notifyWebhookAsync',
    }),
    ...mapActions('new_user',{
      setUuidAsync: 'setUuidAsync',
      isSafari: 'isSafari',
    }),
    getCurrentLang() {
      let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
      return lang === 'ru' ? 'rus' : 'eng';
    },
    requestBuy() {
      this.gtm('buytr');
      this.buyYoungTrees(this.payload)
          .then(() => {
            this.setPromo(null);
          })
          .catch(e => {
            this.$toaster.error(e.response.data.error.message);
          });
    },
    butTree() {
      if (!this.payload.payment_system) {
        this.$toaster.error(this.$t('payMethod'));
        return false;
      }

      const maxAmount = this.maxAmounts[this.payload.payment_system];
      if (maxAmount && this.totalPrice > maxAmount) {
        this.$toaster.error(this.$t('exceedsMaxAmount'));
        return false;
      }
      if (this.payload.payment_system === 'GCFPay') {
        this.initGCFPayment();
        return;
      }


      // find current item in payment system
      let currentItemPayment = this.payments.find(e => e.payment_system === this.payload.payment_system);

      if (!currentItemPayment && this.payload.payment_system === 'BetaTransferCrypto') {
        currentItemPayment = {
          payment_system: 'BetaTransferCrypto',
          restriction: null
        };
      } else if (!currentItemPayment && this.payload.payment_system === 'BetaTransferUkraine') {
        currentItemPayment = {
          payment_system: 'BetaTransferUkraine',
          restriction: null
        };
      } else if (!currentItemPayment && this.payload.payment_system === 'BetaTransferAZN') {
        currentItemPayment = {
          payment_system: 'BetaTransferAZN',
          restriction: null
        };
      } else if (!currentItemPayment && this.payload.payment_system === 'BetaTransferKZT') {
        currentItemPayment = {
          payment_system: 'BetaTransferKZT',
          restriction: null
        };
      }
      else if (!currentItemPayment && this.payload.payment_system === 'GCFPay') {
        currentItemPayment = {
          payment_system: 'GCFPay',
          restriction: null
        };
      }


      if (currentItemPayment.payment_system === 'BetaTransferCrypto') {
        this.showCryptoPopup = true;
      } else {
        this.processPayment();
      }
    },
    initGCFPayment() {
      let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
      lang = lang === 'ru' ? 'rus' : 'eng';

      // Показываем индикатор загрузки
      this.$store.commit('teido_store/SET_LOADING', true);

      const payload = {
        count_trees: this.payload.tree_count,
        payment_system: 'teido'
      };

      if (!!this.payload.promoCode) {
        payload.promo_code = this.payload.promoCode;
      }

      const headers = {
        Authorization: this.uuid,
        'X-Lang-Header': lang,
        'Content-Type': 'application/json'
      };

      // Создаем инвойс для GCF платежа
      axios.post(`${process.env.VUE_APP_NEW_API_URL}/api/teido/buy-trees`, payload, {
      // axios.post(`https://api.nickjazz.online/api/teido/buy-trees`, payload, {
        headers: headers
      }).then(response => {
        if (response.data.success) {
          // Успешное создание инвойса, подготавливаем данные для платежа
          this.gcfPaymentData = {
            amount: response.data.amount,
            currency: "USD",
            invoiceId: response.data.invoice_id,
            invoiceType: "tree",
            description: `Purchase of ${this.payload.tree_count} olive trees`,
            orderId: response.data.invoice_id,
            externalid: response.data.invoice_id,
            uuid: this.uuid,
            language: lang,
            promoCode: this.payload.promoCode,
            billingInfo: {
              email: this.user.email || "",
              address: "",
              city: "",
              postcode: "",
              country: ""
            }
          };

          // Показываем компонент оплаты GCF
          this.showGCFPopup = true;
          this.$store.commit('teido_store/SET_LOADING', false);
        } else {
          this.$store.commit('teido_store/SET_LOADING', false);
          this.$toaster.error(response.data.error || 'Failed to prepare order');
        }
      }).catch(error => {
        this.$store.commit('teido_store/SET_LOADING', false);
        // Формируем сообщение об ошибке
        var errorMessage = 'Error preparing order: ';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage += error.response.data.error;
        } else {
          errorMessage += error.message;
        }
        this.$toaster.error(errorMessage);
      });
    },

// 7. Добавить методы обработки событий от GCFPaymentPopup
    handleGCFPaymentSuccess(result) {
      console.log('GCF Payment success:', result);
      this.showGCFPopup = false;
      this.payload.tree_count = 0;
      this.setPromo(null);

      // Явно вызываем webhook для подтверждения платежа
      this.notifyPaymentSuccess(result).then(() => {
        this.$toaster.success(this.$t('paymentSuccess'));
        this.fetchUser().then(() => {
          this.$router.push({ name: 'personal' });
        });
      }).catch(error => {
        console.error('Error notifying webhook:', error);
        // Даже при ошибке уведомления webhook мы все равно перенаправляем пользователя,
        // так как платеж уже совершен
        this.$toaster.success(this.$t('paymentSuccess'));
        this.fetchUser().then(() => {
          this.$router.push({ name: 'personal' });
        });
      });
    },

    handleGCFPaymentError(error) {
      console.error('GCF Payment error:', error);
      this.showGCFPopup = false;
      this.$toaster.error(error.textError || this.$t('paymentFailed'));
    },

    closeGCFPopup() {
      this.showGCFPopup = false;
    },
    processPayment() {
      let currentItemPayment = this.payments.find(e => e.payment_system === this.payload.payment_system);

      if (!currentItemPayment && this.payload.payment_system === 'BetaTransferCrypto') {
        currentItemPayment = {
          payment_system: 'BetaTransferCrypto',
          restriction: null
        };
      } else if (!currentItemPayment && this.payload.payment_system === 'BetaTransferUkraine') {
        currentItemPayment = {
          payment_system: 'BetaTransferUkraine',
          restriction: null
        };
      } else if (!currentItemPayment && this.payload.payment_system === 'BetaTransferAZN') {
        currentItemPayment = {
          payment_system: 'BetaTransferAZN',
          restriction: null
        };
      } else if (!currentItemPayment && this.payload.payment_system === 'BetaTransferKZT') {
        currentItemPayment = {
          payment_system: 'BetaTransferKZT',
          restriction: null
        };
      }

      if(currentItemPayment.payment_system === 'betatrans'){
        let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
        lang = lang === 'ru' ? 'rus' : 'eng'

        let payload = {
          success_url: `${window.location.origin}${this.$router.resolve({ name: 'personal'}).href}`,
          count_trees: this.payload.tree_count,
        }
        if(!!this.payload.promoCode){
          payload.promo_code = this.payload.promoCode;
        }
        let headers = {
          auth: this.uuid,
          lang: lang,
        }
        this.buyYoungOliveTreesStripeAsync({
          payload:payload,
          headers:headers,
        }).then((result) => {
          this.payload.tree_count = 0
          this.setPromo(null);
          if(result.isSuccess){
            this.isSafari().then((res) => {
              if(res){
                window.location.href = result.pay_url;
              }else{
                window.open(result.pay_url, '_blank')

              }
            })
          }else{
            this.$toaster.error(result.exception.textError)
          }
        });
      }
      else if(['BetaTransferCrypto', 'BetaTransferUkraine', 'BetaTransferAZN', 'BetaTransferKZT'].includes(currentItemPayment.payment_system)){
        let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
        lang = lang === 'ru' ? 'rus' : 'eng'

        let payload = {
          success_url: `${window.location.origin}${this.$router.resolve({ name: 'personal'}).href}`,
          count_trees: this.payload.tree_count,
          payment_system: currentItemPayment.payment_system // Добавлено! Это решает проблему
        }
        if(!!this.payload.promoCode){
          payload.promo_code = this.payload.promoCode;
        }
        let headers = {
          auth: this.uuid,
          lang: lang,
        }
        this.buyYoungOliveTreesBetaTransferAsync({
          payload: payload,
          headers: headers,
        }).then((result) => {
          this.payload.tree_count = 0
          this.setPromo(null);
          if(result.isSuccess){
            this.isSafari().then((res) => {
              if(res){
                window.location.href = result.pay_url;
              } else {
                window.open(result.pay_url, '_blank')
              }
            })
          } else {
            this.$toaster.error(result.exception.textError)
          }
        });
      }

      else{
        // has restriction item
        if (currentItemPayment.restriction) {

          // check max price payment system for selected payment
          if (this.totalPrice < parseInt(currentItemPayment.restriction.max.restriction)) {
            this.requestBuy();
          } else {
            this.$toaster.error(currentItemPayment.restriction.max.error);
          }
        } else {
          // not restriction object (balance)
          const total = this.user.balance + this.user.bonus_balance + this.user.futures_balance;


          // check user balance
          if (currentItemPayment.payment_system === 'balance') {
            if (total < this.totalPrice) {
              this.$toaster.error(this.$t('notEnoughMoney'));
            } else {
              this.requestBuy();
            }
          } else {
            this.requestBuy();
          }
        }
      }
    },
    processCryptoPayment() {
      let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
      lang = lang === 'ru' ? 'rus' : 'eng'

      let payload = {
        success_url: `${window.location.origin}${this.$router.resolve({ name: 'personal'}).href}`,
        count_trees: this.payload.tree_count,
        payment_system: 'BetaTransferCrypto' // Добавлено! Уточняем тип платежной системы
      }
      if (!!this.payload.promoCode) {
        payload.promo_code = this.payload.promoCode;
      }
      let headers = {
        auth: this.uuid,
        lang: lang,
      }
      this.buyYoungOliveTreesBetaTransferAsync({
        payload: payload,
        headers: headers,
      }).then((result) => {
        this.payload.tree_count = 0
        this.setPromo(null);
        if (result.isSuccess) {
          this.isSafari().then((res) => {
            if (res) {
              window.location.href = result.pay_url;
            } else {
              window.open(result.pay_url, '_blank')
            }
          })
        } else {
          this.$toaster.error(result.exception.textError)
        }
      });
    },

    confirmCryptoPayment() {
      this.showCryptoPopup = false;
      this.processPayment(); // Используем общий processPayment для всех платежей
    },

    closeCryptoPopup() {
      this.showCryptoPopup = false;
    },
    ...mapActions({
      fetchPayments: `profileBuyTree/${FETCH_PAYMENTS_SYSTEM}`,
      fetchParams: `profileBuyTree/${BUY_COUNT_FREE_TREES}`,
      fetchData: `profile/${LOAD_USER_DATA}`,
      buyYoungTrees: `shop/${BUY_YOUNG_TREE}`,
      checkPromoCode: `profileBuyTree/${CHECK_PROMO_CODE}`,
      fetchUser: `profile/LOAD_USER_DATA`,
    }),
    ...mapMutations({
      resetSelectYoungTrees: `profileBuyTree/${BUY_SELECT_YOUNG_TREES}`,
      setPromo: `profileBuyTree/${CHECK_PROMO_CODE}`,
      iframeLink: `shop/${PAYMENT_LEOGAMING}`,
      cashPopUpIframe: `shop/${POPUP_BUY_IFRAME}`,
      showPopupFuturesBalance: `profile/CHANGE_TEXT_FUTURES_BALANCE`,
    }),
    gtm(label) {
      this.$gtm.trackEvent({
        event: 'biodep',
        eventCategory: 'userclicks',
        eventAction: 'button',
        eventLabel: label,
      });
    },
    checkPromo: _.debounce(function () {
      if (this.payload.promoCode.length > 0 ) {
        this.checkPromoCode({
          code: this.payload.promoCode,
          promoArea: this.payload.promoArea,
          tree_count: this.payload.tree_count,
        })
            .finally(() => {
              if (this.promoData.discount === null) {
                this.$toaster.error(this.$t('errorPromoCode'));
              }
            })
      }
    }, 2000),

  },
  destroyed() {
    this.setPromo(null);
    this.resetSelectYoungTrees(0);
  }
}